var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-video_svg__a",
    x1: "89.052%",
    x2: "2.642%",
    y1: "12.866%",
    y2: "83.747%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-video_svg__b",
    x1: "89.052%",
    x2: "2.642%",
    y1: "27.778%",
    y2: "70.195%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF684A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF4959"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#3B385E",
    strokeWidth: 1.394,
    transform: "translate(1.518 1.754)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.499,
    height: 17.666,
    fill: "url(#ic-video_svg__a)",
    rx: 1.859
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic-video_svg__b)",
    d: "M12.007 6.78l3.125 4.166a.5.5 0 01-.4.8h-6.25a.5.5 0 01-.4-.8l3.125-4.166a.5.5 0 01.8 0z",
    transform: "rotate(90 11.607 8.996)"
  }))));
}
export default SvgIcVideo;